export default __webpack_public_path__ + "static/media/edit-project-modal-BG.778352bc.png";